export default "__VITE_ASSET__BLQJDOFS__"